import { apiRequestActions } from 'utils/api-request-actions';

export const TEST_ACTION = apiRequestActions('TEST_ACTION');
export const GET_APP_DATA = 'GET_APP_DATA';
export const APP_NOTIFICATION_REFRESH_TOKEN = 'APP_NOTIFICATION_REFRESH_TOKEN';
export const API_REQUEST = 'API_REQUEST';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const USER_SET_TOKEN_DATA = 'USER_SET_TOKEN_DATA';
export const USER_SET_NEW_TOKEN_DATA = 'USER_SET_NEW_TOKEN_DATA';
export const USER_SIGN_AGREEMENT = apiRequestActions('USER_SIGN_AGREEMENT');

export const ACTIVE_AUCTIONS_CHANGE_TABS = 'AUCTIONS_CHANGE_TABS';
export const ACTIVE_AUCTIONS_FETCH_AUCTIONS = apiRequestActions('ACTIVE_AUCTIONS_FETCH_AUCTIONS');
export const ACTIVE_AUCTIONS_FETCH_LISTINGS = apiRequestActions('ACTIVE_AUCTIONS_FETCH_LISTINGS');
export const ACTIVE_AUCTIONS_SEARCH_DICTIONARIES = apiRequestActions(
  'ACTIVE_AUCTIONS_SEARCH_DICTIONARIES'
);
export const ACTIVE_AUCTIONS_PUBLIC_FETCH_LISTINGS = apiRequestActions(
  'ACTIVE_AUCTIONS_PUBLIC_FETCH_LISTINGS'
);
export const FETCH_PUBLIC_ACTIVE_AUCTIONS = apiRequestActions('FETCH_PUBLIC_ACTIVE_AUCTIONS');
export const FETCH_PUBLIC_PREVIEW_AUCTIONS = apiRequestActions('FETCH_PUBLIC_PREVIEW_AUCTIONS');
export const FETCH_PUBLIC_PREVIEW_LISTINGS = apiRequestActions('FETCH_PUBLIC_PREVIEW_LISTINGS');

export const AUCTIONS_FETCH_ACTIVE_TABS = apiRequestActions('AUCTIONS_FETCH_ACTIVE_TABS');
export const AUCTIONS_FETCH_JEWEL_LISTING = apiRequestActions('AUCTIONS_FETCH_JEWEL_LISTING');
export const AUCTIONS_JEWEL_LISTING_CREATE_FAVORITE = apiRequestActions(
  'AUCTIONS_JEWEL_LISTING_CREATE_FAVORITE'
);
export const AUCTIONS_JEWEL_LISTING_DELETE_FAVORITE = apiRequestActions(
  'AUCTIONS_JEWEL_LISTING_DELETE_FAVORITE'
);
export const AUCTIONS_JEWEL_LISTING_UPDATE_FILTER = 'AUCTIONS_JEWEL_LISTING_UPDATE_FILTER';
export const AUCTIONS_JEWEL_LISTINGS_RESET = 'AUCTIONS_JEWEL_LISTINGS_RESET';
export const AUCTIONS_PUBLIC_FETCH_JEWEL_LISTING = apiRequestActions(
  'AUCTIONS_PUBLIC_FETCH_JEWEL_LISTING'
);
export const MY_AUCTIONS_FETCH_AUCTIONS = apiRequestActions('MY_AUCTIONS_FETCH_AUCTIONS');
export const MY_AUCTIONS_CREATE_NEW_AUCTION = apiRequestActions('MY_AUCTIONS_CREATE_NEW_AUCTION');
export const MY_AUCTIONS_FETCH_COMPANY_MEMBERS = apiRequestActions(
  'MY_AUCTIONS_FETCH_COMPANY_MEMBERS'
);

export const MY_AUCTIONS_UPDATE_LISTING = apiRequestActions('MY_AUCTIONS_UPDATE_LISTING');
export const MY_AUCTIONS_REACTIVATE_LISTING = apiRequestActions('MY_AUCTIONS_REACTIVATE_LISTING');
export const MY_AUCTIONS_DELETE_LISTING = apiRequestActions('MY_AUCTIONS_DELETE_LISTING');
export const MY_AUCTIONS_FETCH_LISTING_BIDS = apiRequestActions('MY_AUCTIONS_FETCH_LISTING_BIDS');
export const MY_AUCTIONS_PLACE_BID = apiRequestActions('MY_AUCTIONS_PLACE_BID');
export const MY_AUCTIONS_UPDATE_BID = apiRequestActions('MY_AUCTIONS_UPDATE_BID');
export const MY_AUCTIONS_DELETE_BID = apiRequestActions('MY_AUCTIONS_DELETE_BID');
export const MY_AUCTIONS_UPDATE_LOT_STATUS = apiRequestActions('MY_AUCTIONS_UPDATE_LOT_STATUS');
export const MY_AUCTIONS_UPDATE_LOT_REJECT_BID = apiRequestActions(
  'MY_AUCTIONS_UPDATE_LOT_REJECT_BID'
);

export const MY_AUCTIONS_FETCH_AUCTION = apiRequestActions('MY_AUCTIONS_FETCH_AUCTION');
export const MY_AUCTIONS_UPDATE_AUCTION = apiRequestActions('MY_AUCTIONS_UPDATE_AUCTION');
export const MY_AUCTIONS_FETCH_LISTINGS = apiRequestActions('MY_AUCTIONS_FETCH_LISTINGS');

export const BID_MODAL_CREATE_PUBLIC_BID = apiRequestActions('BID_MODAL_CREATE_PUBLIC_BID');
export const BID_MODAL_RESET_BID = 'BID_MODAL_RESET_BID';
export const BID_MODAL_CREATE_BID = apiRequestActions('BID_MODAL_CREATE_BID');
export const BID_MODAL_DELETE_BID = apiRequestActions('BID_MODAL_DELETE_BID');
export const BID_MODAL_RESOLVE_OFFER = apiRequestActions('BID_MODAL_RESOLVE_OFFER');
export const BID_MAX_MODAL_CREATE_BID = apiRequestActions('BID_MAX_MODAL_CREATE_BID');

export const DOWNLOAD_FILE = apiRequestActions('DOWNLOAD_FILE');
export const DOWNLOAD_FILE_POST = apiRequestActions('DOWNLOAD_FILE_POST');
export const UPLOAD_FILE = apiRequestActions('UPLOAD_FILE');
export const RESET_UPLOAD_ERRORS = 'RESET_UPLOAD_ERRORS';
export const MY_AUCTIONS_FETCH_JEWELRY = apiRequestActions('MY_AUCTIONS_FETCH_JEWELRY');
export const MY_AUCTIONS_ADD_JEWELRY = apiRequestActions('MY_AUCTIONS_ADD_JEWELRY');
export const MY_AUCTIONS_ADD_JEWELRY_TOGGLE_ALL_CHECKBOX =
  'MY_AUCTIONS_ADD_JEWELRY_TOGGLE_ALL_CHECKBOX';
export const MY_AUCTIONS_ADD_JEWELRY_TOGGLE_CHECKBOX = 'MY_AUCTIONS_ADD_JEWELRY_TOGGLE_CHECKBOX';
export const MY_AUCTIONS_ADD_JEWELRY_RESET = 'MY_AUCTIONS_ADD_JEWELRY_RESET';
export const MY_AUCTIONS_GET_DEFAULT_INCREMENT_BID = apiRequestActions(
  'MY_AUCTIONS_GET_DEFAULT_INCREMENT_BID'
);
export const MY_AUCTIONS_LOT_CHANGE_DESCRIPTION = apiRequestActions(
  'MY_AUCTIONS_LOT_CHANGE_DESCRIPTION'
);

export const ACCOUNTS_SEARCH = apiRequestActions('ACCOUNTS_SEARCH');
export const NOT_APPROVED_ACCOUNTS_SEARCH = apiRequestActions('NOT_APPROVED_ACCOUNTS_SEARCH');
export const ACCOUNTS_ADD_BIDDER = apiRequestActions('ACCOUNTS_ADD_BIDDER');
export const ACCOUNTS_REMOVE_BIDDER = apiRequestActions('ACCOUNTS_REMOVE_BIDDER');
export const ACCOUNTS_CHANGE_PASSWORD = apiRequestActions('ACCOUNTS_CHANGE_PASSWORD');
export const ACCOUNTS_CHANGE_AUTH_TYPE = apiRequestActions('ACCOUNTS_CHANGE_AUTH_TYPE');

export const SEND_VISITOR_INFO = apiRequestActions('SEND_VISITOR_INFO');
export const SEND_VISITOR_EMAIL = apiRequestActions('SEND_VISITOR_EMAIL');
export const GET_RECENTLY_ITEMS = apiRequestActions('GET_RECENTLY_ITEMS');
export const SEND_CONTACT_INFO = apiRequestActions('SEND_CONTACT_INFO');
export const GET_CONTACT_ITEMS = apiRequestActions('GET_CONTACT_ITEMS');
export const APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN = apiRequestActions(
  'APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN'
);
export const AUCTIONS_HIGHEST_BID_CHANGED = 'AUCTIONS_HIGHEST_BID_CHANGED';
export const AUCTIONS_UPDATE_HIGHEST_BID = 'AUCTIONS_UPDATE_HIGHEST_BID';
export const APP_INCOMING_MESSAGE = 'APP_INCOMING_MESSAGE';

/* MANAGE MEDIA FILES */
export const MANAGE_MEDIA_UPLOAD = 'MANAGE_MEDIA_UPLOAD';
export const REMOVE_ASSIGNED_MEDIA = 'REMOVE_ASSIGNED_MEDIA';
export const MANAGE_MEDIA_ADD = apiRequestActions('MANAGE_MEDIA_ADD');
export const MANAGE_GET_EXISTING_IMAGES = apiRequestActions('MANAGE_GET_EXISTING_IMAGES');
export const MANAGE_GET_PRESIGNED_URL = apiRequestActions('MANAGE_GET_PRESIGNED_URL');
export const MANAGE_PUT_IMAGE_BY_URL = apiRequestActions('MANAGE_PUT_IMAGE_BY_URL');
export const MANAGE_MARK_FILE_AS_UPLOADED = apiRequestActions('MANAGE_MARK_FILE_AS_UPLOADED');
export const MANAGE_MEDIA_RESET = 'MANAGE_MEDIA_RESET';

export const MANAGE_MEDIA_UPLOAD_LAB_REPORT = apiRequestActions('MANAGE_MEDIA_UPLOAD_LAB_REPORT');
export const MANAGE_MEDIA_UPLOAD_APPRAISAL = apiRequestActions('MANAGE_MEDIA_UPLOAD_APPRAISAL');

export const MANAGE_MARK_CERTIFICATE_AS_UPLOADED = apiRequestActions(
  'MANAGE_MARK_CERTIFICATE_AS_UPLOADED'
);

export const ACCOUNTS_SEND_EMAIL = apiRequestActions('ACCOUNTS_SEND_EMAIL');
